import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import PageShell from '../components/PageShell';
import { siteConfig } from '../data/site';

const sections = [
  {
    title: '1. Introdução',
    content:
      'Esta Política de Privacidade descreve como a MS Digitais, de responsabilidade de Monise Da Silva, coleta, utiliza e protege os dados pessoais dos visitantes deste site. Ao utilizar nossos serviços ou enviar informações por meio do site, você concorda com as práticas descritas neste documento, em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018).',
  },
  {
    title: '2. Controladora dos dados',
    content:
      'A controladora dos dados pessoais tratados por meio deste site é Monise Da Silva, MS Digitais, responsável pelo desenvolvimento de sites institucionais e sistemas personalizados. Para dúvidas sobre privacidade, entre em contato pelos canais disponíveis neste site, como WhatsApp e Instagram.',
  },
  {
    title: '3. Dados que podemos coletar',
    content: null,
    list: [
      'Dados informados voluntariamente no formulário de orçamento, como nome, telefone/WhatsApp, tipo de serviço, nicho, descrição do projeto, situação atual do site, prazo e origem do contato.',
      'Dados enviados ao entrar em contato pelo WhatsApp ou Instagram, conforme as informações que você compartilhar.',
      'Preferência de tema (modo claro ou escuro), armazenada localmente no seu navegador.',
      'Dados técnicos básicos de navegação, como tipo de dispositivo, navegador e páginas acessadas, quando aplicável por ferramentas de hospedagem ou analytics.',
    ],
  },
  {
    title: '4. Finalidade do tratamento',
    content: null,
    list: [
      'Responder solicitações de orçamento e dúvidas sobre serviços.',
      'Entrar em contato para apresentação de propostas e andamento comercial.',
      'Melhorar a experiência de navegação no site.',
      'Cumprir obrigações legais, quando necessário.',
    ],
  },
  {
    title: '5. Compartilhamento de dados',
    content:
      'Seus dados não são vendidos. O compartilhamento ocorre apenas quando necessário para operação do site, envio de mensagens, hospedagem ou cumprimento de obrigação legal. Serviços de terceiros utilizados podem incluir plataformas de hospedagem, comunicação e ferramentas técnicas indispensáveis à prestação do serviço.',
  },
  {
    title: '6. Armazenamento e segurança',
    content:
      'Adotamos medidas razoáveis de segurança para proteger os dados contra acesso não autorizado, perda ou uso indevido. As informações são mantidas pelo tempo necessário para atender à finalidade do contato, elaboração de propostas e eventuais obrigações legais.',
  },
  {
    title: '7. Seus direitos',
    content:
      'Nos termos da LGPD, você pode solicitar confirmação de tratamento, acesso, correção, anonimização, eliminação, informações sobre compartilhamento e revogação de consentimento, quando aplicável. Para exercer seus direitos, entre em contato pelos canais disponíveis no site.',
  },
  {
    title: '8. Cookies e armazenamento local',
    content:
      'Este site pode utilizar armazenamento local do navegador para salvar preferências, como o tema visual escolhido. Essas informações ficam no seu dispositivo e podem ser removidas nas configurações do navegador.',
  },
  {
    title: '9. Portfólio e confidencialidade',
    content:
      'Os projetos exibidos no portfólio são apresentados por segmento de atuação, sem exposição desnecessária de dados pessoais ou identificação de clientes, respeitando a confidencialidade e a imagem profissional de cada projeto.',
  },
  {
    title: '10. Alterações desta política',
    content:
      'Esta Política de Privacidade pode ser atualizada a qualquer momento. Recomendamos a consulta periódica desta página. Alterações relevantes passam a valer a partir da publicação no site.',
  },
  {
    title: '11. Contato',
    content: `Para assuntos relacionados à privacidade e proteção de dados, utilize os canais oficiais da MS Digitais disponíveis neste site, como WhatsApp (${siteConfig.whatsappDisplay}) e Instagram (${siteConfig.instagramHandle}).`,
  },
];

const PoliticaPrivacidade = () => {
  const updatedAt = '19 de junho de 2026';

  return (
    <PageShell>
      <section className="pt-28 pb-20 md:pt-32 md:pb-28">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-semibold text-burnt hover:text-primary-700 transition-colors mb-8 font-body"
          >
            <FaArrowLeft />
            Voltar ao site
          </Link>

          <div className="mb-10">
            <p className="text-burnt font-heading font-semibold uppercase tracking-wider text-sm mb-3">
              Legal
            </p>
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-dark dark:text-cream mb-4">
              Política de Privacidade
            </h1>
            <p className="text-sm text-dark/50 dark:text-cream/50 font-body">
              Última atualização: {updatedAt}
            </p>
          </div>

          <div className="rounded-3xl border border-brown/10 dark:border-burnt/10 bg-white dark:bg-dark-surface shadow-card dark:shadow-card-dark p-6 md:p-10 space-y-8">
            {sections.map((section) => (
              <div key={section.title}>
                <h2 className="text-xl font-heading font-semibold text-dark dark:text-cream mb-3">
                  {section.title}
                </h2>
                {section.content && (
                  <p className="text-dark/80 dark:text-cream/80 font-body leading-relaxed">
                    {section.content}
                  </p>
                )}
                {section.list && (
                  <ul className="mt-3 space-y-2 list-disc pl-5 text-dark/80 dark:text-cream/80 font-body leading-relaxed">
                    {section.list.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default PoliticaPrivacidade;
